module.exports = __webpack_public_path__ + "img/17839_S.505f2626.png";